/* eslint-disable import/prefer-default-export */
import { map, orderBy } from 'lodash';

const splitAuthorName = (authorName) => {
  if (!authorName) return { firstName: '', lastName: '' };
  const trimmed = String(authorName).trim();
  if (!trimmed) return { firstName: '', lastName: '' };

  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' };
  }
  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(' '),
  };
};

export const transformShipmentNote = (note) => {
  const { firstName, lastName } = splitAuthorName(note?.authorName);

  return {
    noteId: note.id,
    noteContent: note.content,
    noteState: note.state,
    noteCreatedAt: note.createdAt,
    noteAuthor: {
      firstName,
      lastName,
      pomUserId: note.authorId || '',
    },
    noteContextType: note.contextType,
    noteContextId: note.contextId,
  };
};

export const transformShipmentNotes = (notes) => {
  if (!notes || notes.length === 0) return [];
  const transformed = map(notes, transformShipmentNote);
  return orderBy(transformed, ['noteCreatedAt'], ['desc']);
};
